export default function Hero() {
  const handleContact = () => {
    const el = document.querySelector('#contato');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/51edf26e-7d07-4b8d-9c04-2ec039cb5f0f_croquis-teste.png?v=57b6dc8e7355545c3f9c797580d6422a"
          alt="André Mares Arquitetura - Projeto de Alto Padrão"
          className="w-full h-full object-cover object-center"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/85 via-[#0A0A0A]/50 to-[#0A0A0A]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/60 via-transparent to-[#0A0A0A]/30" />
      </div>

      {/* Decorative vertical line */}
      <div className="absolute left-[10%] top-1/2 -translate-y-1/2 w-[1px] h-[120px] bg-[#A3B18A]/30 hidden lg:block" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-[640px]">
          {/* Headline */}
          <h1 className="font-['Montserrat'] font-bold text-4xl md:text-5xl lg:text-[64px] text-white leading-[1.1] mb-6 animate-fade-in-up opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
            Arquitetura pensada com<br />
            <span className="text-[#A3B18A]">proporção, clareza</span><br />
            e viabilidade.
          </h1>

          {/* Subheadline */}
          <p className="font-['Montserrat'] text-base md:text-lg text-[#EDEDED]/90 leading-relaxed mb-10 max-w-[520px] animate-fade-in-up opacity-0" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
            Projetos residenciais e empreendimentos desenvolvidos com qualidade formal e consistência técnica.
          </p>

          {/* CTA Button */}
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
            <button
              onClick={handleContact}
              className="px-10 py-4 bg-[#A3B18A] text-[#0A0A0A] font-['Montserrat'] font-bold text-sm tracking-widest uppercase rounded-full hover:scale-105 hover:shadow-[0_8px_24px_rgba(163,177,138,0.4)] transition-all duration-400 cursor-pointer whitespace-nowrap"
            >
              Entrar em contato
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-[#EDEDED]/50 font-['Montserrat'] text-[10px] tracking-[3px] uppercase">Scroll</span>
        <div className="w-[1px] h-8 bg-gradient-to-b from-[#EDEDED]/50 to-transparent" />
      </div>
    </section>
  );
}
